import Header from "./Header/Header"
import Logo from "../../assets/Logo.png";
import { FooterAddress, FooterAddressContent, FooterAddressHeading, FooterContainer, FooterLogo, LayoutContainer, ZigZagBottom } from "./styled";

const Layout: React.FC<React.PropsWithChildren> = ({children}) => {
    return <>
        <Header />
        <LayoutContainer>
        {children}
        </LayoutContainer>
        <ZigZagBottom>
            <FooterContainer>
                <FooterLogo src={Logo} />
                <FooterAddress>
                    <FooterAddressHeading>Registered Office:</FooterAddressHeading>
                    <FooterAddressContent>
                        TELMA MICRO NEEDLES PRIVATE LIMITED
                        NO. 56/6, MAJARAHOSAHALLI MAIN ROAD,
                        DODDABALLAPUR, BANGALORE - 561203
                    </FooterAddressContent>
                </FooterAddress>
            </FooterContainer>
        </ZigZagBottom>
    </>
}

export default Layout;